import ChatIcon from '~/icons/ChatIcon';

import styles from './CommentPlaceholder.module.scss';

const CommentPlaceholder = () => {
  return (
    <>
      <div className={styles.break}></div>
      <div className={styles.box}>
        <div className={styles.content}>
          <ChatIcon />
          <p className={styles.heading}>Be the first to comment</p>
          <p className={styles.text}>
            Add your thoughts and get the conversation going.
          </p>
        </div>
      </div>
    </>
  );
};

export default CommentPlaceholder;
